import { plainToClass, classToPlain } from 'class-transformer';
import { PlacedOrderModel, DeliveryTypes, stringToDeliveryTypes } from 'models';
import { BasketDetailsModel, BasketInfoModel } from 'models/Basket';

const SOFOLOGY_BASKET_STORAGE_KEY = 'sofologyBasket';
const SOFOLOGY_ORDERS_STORAGE_KEY = 'sofologyOrders';
const SOFOLOGY_DELIVERY_TYPE = 'sofologyDeliveryType';

export class BasketHelper {
    public getBasket(): BasketDetailsModel | null {
        let basketJson = localStorage.getItem(SOFOLOGY_BASKET_STORAGE_KEY);

        return basketJson ? plainToClass(BasketDetailsModel, JSON.parse(basketJson)) : null;
    }

    public saveBasket(basket: BasketInfoModel): void {
        localStorage.setItem(SOFOLOGY_BASKET_STORAGE_KEY, JSON.stringify(classToPlain(basket)));
    }

    public removeBasket(): void {
        localStorage.removeItem(SOFOLOGY_BASKET_STORAGE_KEY);
    }

    public preserveOrder(order: PlacedOrderModel): void {
        const orders = [];
        const previousOrdersString = localStorage.getItem(SOFOLOGY_ORDERS_STORAGE_KEY);

        if (previousOrdersString) {
            const previousOrders: PlacedOrderModel[] = plainToClass(PlacedOrderModel, JSON.parse(previousOrdersString) as any[] || []);

            orders.push(...previousOrders);
        }

        orders.push({
            orderCode: order.code,
            guid: order.guid,
            store: order.placementStore
        });

        localStorage.setItem(SOFOLOGY_ORDERS_STORAGE_KEY, JSON.stringify(orders));
    }

    public saveDeliveryType(deliveryType: DeliveryTypes): void {
        localStorage.setItem(SOFOLOGY_DELIVERY_TYPE, deliveryType);
    }

    public getDeliveryType(): DeliveryTypes | null {
        const delivetyType = localStorage.getItem(SOFOLOGY_DELIVERY_TYPE);

        return delivetyType ? stringToDeliveryTypes(delivetyType) : null;
    }

    public removeDeliveryType(): void {
        localStorage.removeItem(SOFOLOGY_DELIVERY_TYPE);
    }

    public resetEcommerceStorage(): void {
        localStorage.removeItem('sofaShield');
        localStorage.removeItem('leatherKit');
        localStorage.removeItem('fabricKit');
        localStorage.removeItem('sofologyDeliveryState');
        localStorage.removeItem('sofology-addresses');
        localStorage.removeItem('paymentDetails');
        localStorage.removeItem('financeApplication');
        localStorage.removeItem('currentOrder');
        localStorage.removeItem('sofologyOrders');
        localStorage.removeItem('financeInfo');
    }
}

export const basketStorage = new BasketHelper();